import { Provider, useDispatch, useSelector } from 'react-redux'
import './App.scss'
import ScrollTop from './ScrollTop'
import {
  DeviceMode,
  GoTopPage,
  LoadingFit,
  NotificationManager,
  PrimaryLayout,
} from './share/Components'
import store, { persistor } from './storeManager/store'
import { PersistGate } from 'redux-persist/integration/react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { QueryClient } from 'react-query'
import { QueryClientProvider } from 'react-query'
import axios, { AxiosError } from 'axios'
import { ReducerType } from './storeManager/ReducerType'
import { LoginInterface } from './Interfaces/LoginInterface'
import useFetch from './_services/fetch'
import { RaytebRequests } from './_services'
import { loginUser } from './storeManager/Reducers/userSlice'
import ReactModal from 'react-modal'
import { useEffect, useState } from 'react'
import { setCenter } from './storeManager/Reducers/centerSlice'

const queryClient = new QueryClient()
function App({ children }) {
  const Layout = children.type.Layout || PrimaryLayout
  const GoToPage = children.type.GoToPage || GoTopPage
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const device = useSelector<ReducerType, DeviceModeInterface>(
    (state) => state.reducerDevice
  )
  const dispatch = useDispatch()
  const [isVerifyToken, setIsVerifyToken] = useState<boolean>(false)

  const refreshToken = useFetch<LoginInterface>({
    request: RaytebRequests.Dashboard_RefreshToken_POST(),
    onSuccess(data) {
      setIsVerifyToken(true)
      dispatch(loginUser(data))
    },
    onStatusCode400() {
      setIsVerifyToken(false)
      dispatch(loginUser(null))
      window.location.href = `${window.env['APP_Rayteb_Domain']}/rayteb/fa-ir/Account/Login`
    },
    fetchInitialLoad: true,
  })
  // const { reFetch, isLoading } = useFetch<LoginInterface>({
  //   request: RaytebRequests.Dashboard_Login_POST(),
  //   onSuccess(data) {
  //     dispatch(loginUser(data))
  //     setTimeout(() => {
  //       window.location.reload()
  //     }, 300)
  //   },
  //   onStatusCode400(data) {
  //     window.location.href = `${process.env['REACT_APP_Rayteb_Domain']}/rayteb/fa-ir/Account/Login`
  //   },
  // })
  axios.interceptors.response.use(
    (res) => {
      return res
    },
    (err: AxiosError) => {
      if (err.response?.status === 401 && !refreshToken.isLoading && err.request.responseURL.includes('DoctorProfile')) {
        refreshToken.reFetch()
      }

      return Promise.reject(err)
    }
  )

  return (
    <>
      <PersistGate persistor={persistor}>
        <DeviceMode />
        {!refreshToken.isLoading && <NotificationManager />}
        <ScrollTop goTopPage={<GoToPage />}>
          <>
            {refreshToken.isLoading || !isVerifyToken ? (
              <ReactModal
                isOpen={true}
                className={
                  'w-screen h-screen bg-white fixed !z-[99] flex justify-center items-center'
                }
              >
                <p>در حال احراز هویت ....</p>
              </ReactModal>
            ) : (
              <Layout>{children}</Layout>
            )}
            <ToastContainer
              position={`${device.Desktop ? 'top-right' : 'top-center'}`}
              bodyClassName={'text-center text-xs '}
              toastClassName={'!mb-1 '}
              className={'xs:grid xs:grid-cols-2 xs:gap-1 !z-[9999999999] '}
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme='light'
            />
          </>
        </ScrollTop>
      </PersistGate>
    </>
  )
}

function AppWrapper<ComponentProps>(
  Component: React.FunctionComponent<ComponentProps>
) {
  function ComponentTemp(props: ComponentProps) {
    return (
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Component {...props!} />
        </QueryClientProvider>
      </Provider>
    )
  }

  return ComponentTemp
}
export default AppWrapper(App)
